import { useCallback, useMemo } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $convertFromMarkdownString } from '@lexical/markdown';
import { insertMarkdownToEditor } from 'src/utils';
import { useClearEditorText } from './useClearEditorText';
import { ArtifactMarkdownV3 } from 'src/types';
import { TRANSFORMERS_LIST } from 'src/v2/components/Editor/constants/transformers';

export const useInsertTextToEditor = () => {
  const [editor] = useLexicalComposerContext();
  const { clearEditorText } = useClearEditorText();

  const insertTextToEditor = useCallback(
    ({ markdown }: { markdown: string }) => {
      insertMarkdownToEditor({ editor, markdown });
    },
    [editor],
  );

  const replaceTextInEditor = useCallback(
    ({ markdown }: { markdown: string }) => {
      clearEditorText();

      insertMarkdownToEditor({ editor, markdown });
    },
    [editor, clearEditorText],
  );

  const replaceTextWithArtifact = useCallback(
    (artifact: ArtifactMarkdownV3) => {
      editor.update(() => {
        $convertFromMarkdownString(artifact.fullMarkdown, TRANSFORMERS_LIST);
      });
    },
    [editor],
  );

  return useMemo(
    () => ({
      insertTextToEditor,
      replaceTextInEditor,
      replaceTextWithArtifact,
    }),
    [insertTextToEditor, replaceTextInEditor, replaceTextWithArtifact],
  );
};
